export const setBrowserTimezone = (timeZone: string): void => {
  localStorage.setItem('webmail_browser_time_zone', timeZone);
};

export const getBrowserTimezone = (): string | null => {
  return localStorage.getItem('webmail_browser_time_zone');
};
